import React from "react";
import { Timer } from "lucide-react";
import { QueryObserverResult } from "react-query";
import {
  COLOURS,
  DataTypes,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card } from "../card";
import {
  getUnbilledTimeAndFeesDescription,
  getTemplateKey,
} from "../../functions/workflowFunctions";
import { CardDescription } from "../cardDescription";

interface CardUnbilledTimeAndFeeProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
  region: string;
}

export const CardUnbilledTimeAndFee: React.FC<CardUnbilledTimeAndFeeProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
  region,
}) => {
  const unbilledTimeFeeImport = data?.imports.find((i) => i.importType === "unbilledTimeAndFee");

  return (
    <Card
      image={
        <Timer
          size={60}
          color={COLOURS.cardIconColor}
          strokeWidth={2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.625rem",
          }}
        />
      }
      importType="unbilledTimeAndFee"
      templateKey={getTemplateKey("unbilledTimeAndFee", region)}
      fileName="unbilledTimeAndFee.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find(
        (i) => i.importType === "unbilledTimeAndFee",
      )}
      headerText={DataTypes.UnbilledTimeAndFees}
      description={
        <CardDescription
          {...getUnbilledTimeAndFeesDescription(region, unbilledTimeFeeImport)}
          displayWiderColumn={true} // Pass the displayWiderColumn flag prop as true for all unbilled time and fees
        />
      }
      cardState={cardsState["unbilledTimeAndFee"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
    />
  );
};
